import { useGetCompany } from "@/entities/get-company/fetch";
import { useAuth } from "@/shared/auth/fetch/useAuth";
import { useMemo } from "react";
import type { FooterLinkType } from "../constant";
import type { TheFooterProps } from "../model/types";

const TERMS_LINKS = {
  shipper: "https://logipoke.com/term2",
  carrier: "https://logipoke.com/term3",
  default: "https://logipoke.com/term2",
} as const;

const BASE_FOOTER_LINKS: Array<{ label: string; href?: string }> = [
  { label: "利用規約" },
  { label: "プライバシーポリシー", href: "https://www.xmile.co.jp/policy/01" },
  { label: "会社情報", href: "https://www.xmile.co.jp/" },
];

export const useTheFooterProps = (): TheFooterProps => {
  const auth = useAuth();

  const companyId = auth.session.isAuthenticated
    ? auth.session.user.companyId
    : 0;

  const getCompany = useGetCompany(
    {
      id: companyId,
    },
    {
      enabled: auth.session.isAuthenticated,
    },
  );

  const footerLinks = useMemo<FooterLinkType[]>(() => {
    const companyData = getCompany.data;

    // 会社カテゴリに基づいて利用規約のリンクを決定
    let termsLink: string = TERMS_LINKS.default;
    if (companyData?.data.category?.includes("shipper")) {
      termsLink = TERMS_LINKS.shipper;
    } else if (companyData?.data.category?.includes("carrier")) {
      termsLink = TERMS_LINKS.carrier;
    }

    return BASE_FOOTER_LINKS.map((link) => ({
      label: link.label,
      href: link.label === "利用規約" ? termsLink : link.href || "",
    }));
  }, [getCompany.data]);

  return {
    footerLinks,
  };
};
